import script from "./MenuLateralPerfilUsuario.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuLateralPerfilUsuario.vue?vue&type=script&setup=true&lang=js"

import "./MenuLateralPerfilUsuario.vue?vue&type=style&index=0&id=d54452aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d54452aa"]])

export default __exports__